import { create } from 'zustand';
import {
  Appearance,
  ThemeSetting,
  applyAppearance,
  readStoredTheme,
  resolveAppearance,
  storeTheme,
} from '../lib/theme';

interface ThemeState {
  /** What the user chose: light, dark, or follow the system. */
  setting: ThemeSetting;
  /** What is actually rendered right now. */
  appearance: Appearance;
  setTheme: (setting: ThemeSetting) => void;
  /** Re-resolves after the OS preference changes; a no-op unless on "system". */
  syncWithSystem: () => void;
}

const initialSetting = readStoredTheme();

export const useThemeStore = create<ThemeState>((set, get) => ({
  setting: initialSetting,
  appearance: resolveAppearance(initialSetting),

  setTheme: setting => {
    const appearance = resolveAppearance(setting);
    storeTheme(setting);
    applyAppearance(appearance);
    set({ setting, appearance });
  },

  syncWithSystem: () => {
    if (get().setting !== 'system') {
      return;
    }
    const appearance = resolveAppearance('system');
    applyAppearance(appearance);
    set({ appearance });
  },
}));
